export default "<ep-photography-blog-preview></ep-photography-blog-preview>"